var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var FirstButton = require('./firstButton.jsx');

var HeroTextBlock = createReactClass({
    mixins: [PureRenderMixin],

	render: function(){
        var descriptionNodes = this.props.descriptions.map(function(des, i){
            return (
                <p key={i}>{des}</p>
            );
        });

		return (
            <div className="hero-text-block">
                <h2>{this.props.title}</h2>
                {descriptionNodes}
                <FirstButton
                    firstButton={this.props.firstButton}
                    size={this.props.size || 'large'}
                    clickTracking={this.props.clickTracking} />
            </div>
	    )
	}
});

module.exports = HeroTextBlock;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/layout/heroTextBlock.jsx